import React from 'react';
import { Typography, Grid, Link, Box } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { motion } from 'framer-motion';
import {WithTranslation, withTranslation} from "react-i18next";

interface FooterProps extends WithTranslation {}

class Footer extends React.Component<FooterProps> {
    private currentYear: number = new Date().getFullYear();

    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    render(): JSX.Element {
        const { t } = this.props;
        return (
            <Box component="footer" sx={{ textAlign: 'center', p: 4, background: '#0A74DA', color: '#fff', borderTop: '1px solid #ffffff' }}>
                <Grid container spacing={3} justifyContent="space-between">
                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom color="inherit">
                            {t('socialMedia')}
                        </Typography>
                        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
                            <Link href="https://www.linkedin.com/in/przemys%C5%82aw-tarapacki-6b175a229/" target="_blank" color="inherit" underline="none" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px', mb: 1 }}>
                                <LinkedInIcon sx={{ fontSize: '40px', mb: 1.5 }} />
                                LinkedIn
                            </Link>
                        </motion.div>
                        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
                            <Link href="https://github.com/Przemekhasz" target="_blank" color="inherit" underline="none" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                                <GitHubIcon sx={{ fontSize: '40px', mb: 1.5 }} />
                                GitHub
                            </Link>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <Typography variant="h4" gutterBottom color="inherit">
                            CodeCronner
                        </Typography>
                        <Typography variant="body2" color="#fff" sx={{ mt: 1 }}>
                            NIP: 7922321331
                        </Typography>
                        <Typography variant="body2" color="#fff" sx={{ mt: 1 }}>
                            REGON: 526693970
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <Typography variant="h6" gutterBottom color="inherit">
                            {t('contact')}
                        </Typography>
                        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
                            <Link href="mailto:przemyslaw.tarapacki@codecronner.com" color="inherit" underline="none" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px', mb: 1 }}>
                                <EmailIcon sx={{ fontSize: '40px', mb: 1.5 }} />
                                przemyslaw.tarapacki@codecronner.com
                            </Link>
                        </motion.div>
                        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
                            <Link href="tel:123456789" color="inherit" underline="none" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                                <PhoneIcon sx={{ fontSize: '40px', mb: 1.5 }} />
                                +48 725 427 489
                            </Link>
                        </motion.div>
                    </Grid>
                </Grid>

                <Typography variant="body2" color="#fff" sx={{ mt: 3 }}>
                    © {this.currentYear} PRZEMYSŁAW TARAPACKI CodeCrooner. {t('allRightsReserved')}
                </Typography>
                <Typography variant="body1" color="#fff" sx={{ mt: 3 }}>
                    {t('inviteToCooperate')}
                </Typography>
            </Box>
        );
    }
}

export default withTranslation()(Footer);
